/**
 * How an agent is installed on a server (ADR-0009, ADR-0036): in one place, so
 * the panel installing it over SSH runs exactly what an operator would paste.
 */
export function agentInstallArgs(issued: { readonly role: 'node' | 'host'; readonly token: string }): readonly string[] {
  // A host keeps its ports and firewall as they are; a node of the panel's is
  // closed to all but Cloudflare on 80 and 443.
  return issued.role === 'host'
    ? ['--host', '--install-deps', '--token', issued.token]
    : ['--install-deps', '--cloudflare-only', '--token', issued.token];
}

/** The two commands an operator runs on the server by hand. */
export function agentInstallCommands(issued: { readonly role: 'node' | 'host'; readonly token: string; readonly installUrl: string }): {
  readonly download: string;
  readonly install: string;
} {
  return {
    download: `curl -fsSL ${issued.installUrl} -o cp-agent-install.sh`,
    install: `sudo bash cp-agent-install.sh ${agentInstallArgs(issued).join(' ')}`,
  };
}

/** Why installing over SSH did not go ahead, for the interface to say in its own words. */
export const AGENT_INSTALL_REASONS = [
  'unreachable',
  'refused',
  'timeout',
  'auth',
  'key_invalid',
  'host_key_changed',
  'not_root',
  'download',
  'installer',
  'interrupted',
] as const;

export type AgentInstallReason = (typeof AGENT_INSTALL_REASONS)[number];
